var actions, types;

types = {
  INVALIDATE_CARDS: 'invalidate-cards',
  REQUEST_CARDS: 'request-cards',
  RECEIVE_CARDS: 'receive-cards'
};

actions = {
  invalidateCards: function() {
    return {
      type: types.INVALIDATE_CARDS
    };
  },
  requestCards: function() {
    app.socket.emit('data', {
      endpoint: '/cards/list'
    });
    return {
      type: types.REQUEST_CARDS
    };
  },
  receiveCards: function(cards) {
    return {
      type: types.RECEIVE_CARDS,
      cards: cards,
      receivedAt: Date.now()
    };
  }
};

Object.assign(actions, types);

module.exports = actions;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/actions/cards.coffee
 ** module id = 243
 ** module chunks = 0
 **/